var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.isCustom)?_c(_vm.typeName,{ref:"isComponent",tag:"component",attrs:{"name":_vm.name,"initFunc":_vm.initFunc},on:{"sure":_vm.handlerSure}}):_c('span',{attrs:{"title":_vm.name}},[_vm._v(_vm._s(_vm.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }